module.exports = __webpack_public_path__ + "static/slack-0653917840fd6e7dadcf5235c2d71cf7.jpg";